function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M1.26161 11.6076H13.7384C14.8603 11.6076 15.4212 12.9088 14.6296 13.6674L8.3912 19.6458C7.89842 20.1181 7.10158 20.1181 6.61404 19.6458L0.370408 13.6674C-0.421187 12.9088 0.139744 11.6076 1.26161 11.6076ZM14.6296 6.33258L8.3912 0.354182C7.89842 -0.118061 7.10158 -0.118061 6.61404 0.354182L0.370408 6.33258C-0.421187 7.09118 0.139744 8.39236 1.26161 8.39236H13.7384C14.8603 8.39236 15.4212 7.09118 14.6296 6.33258Z"
});

var SvgCaretIconDouble = function SvgCaretIconDouble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretIconDouble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-icon-double.f9844fdb.svg";
export { ForwardRef as ReactComponent };